import PropTypes from 'prop-types';
import React from 'react';

export const BreakPriceWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'BREAK_PRICE',
    category: 'Exit',
    type: 'Break Price',
    domain: 'Underlying',
  };
  const priceToBreak = softOrder.priceToBreak;
  return <Component details={details} priceToBreak={priceToBreak} {...rest} />;
};

BreakPriceWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    priceToBreak: PropTypes.any
  })
};



